module.exports = __webpack_public_path__ + "static/img/repast_4.9365199c.jpg";